<template>
    <v-sheet class="defaultCard" color="bgtopology">
        <span  class="titlePages"> {{  t('analyticsPage.titlesnr') }}</span>
        <v-row  class="ma-0"  v-if="showCard" >

            <!-- CARD LIST ITEMS -->
            <!-- <v-sheet color="transparent"> -->
                <v-col  
                class="my-3" 
                cols="12" sm="4" md="3" lg="2" xl="2"
                v-for="(item,i) in arrayPredictSNR" 
                :key="i"            
                >
                    <CardTopology
                    :status="item.status"
                    :ip="item.ip"
                    :title="item.name"
                    :description="item.tipo"            
                    @click="showDialog(item.ip,item.name)"
                    />
                </v-col>
            <!-- </v-sheet> -->
            <!-- DIALOG -->
            <v-dialog
            v-model="dialog"
            width="85%"
            >
                <v-card class="card_dialog" color="background">
                    <v-row class="ma-0" justify="space-between" style="align-items: self-end !important;" >
                        <v-col cols="10">
                            <h4 v-if="xs"> {{ t('title.graphTitle')}} {{ titleDialog }}</h4>
                            <h2 v-else> {{ t('title.graphTitle')}} {{ titleDialog }}</h2>
                        </v-col>
                        <v-col cols="1">
                            <v-btn icon="mdi-close" variant="plain" @click="dialog = false"></v-btn>
                        </v-col>
                        <v-col v-if="valorPredVER.length !== 0" cols="12" :style="xs ? 'text-align:start' :'text-align:end'" class="pb-1">
                            <span :class="xs ? 'datePredict' : ''">
                                {{ t('analyticsPage.valueVert') }} [ {{  titleDateVER }} ] - {{ t('analyticsPage.titleDial2') }} {{  titleValueVER }}
                            </span>
                        </v-col>
                        <v-col v-if="valorPredHOR.length !== 0" cols="12" :style="xs ? 'text-align:start' :'text-align:end'" class="pt-1">
                            <span :class="xs ? 'datePredict' : ''">
                                {{ t('analyticsPage.valueHorz') }} [ {{  titleDateHOR }} ] - {{ t('analyticsPage.titleDial2') }} {{  titleValueHOR }}
                            </span>
                        </v-col>
                    </v-row>

                    <v-divider></v-divider>
                     <v-sheet class=" defaultCard text-center "  color="bgtopology">
                        <CompareCharts
                        v-if="valorRealHOR.length !== 0"
                        name-primary="Real" 
                        :first-array="valorRealHOR" 
                        :color-first="COLOR.compare3"
                        :color-second="COLOR.compare2"
                        :name-secundary="t('labels.predict')" 
                        :second-array="valorPredHOR" 
                        :subtitle="''"
                        :title="t('analyticsPage.predvsreal2') + ' Horizontal' " 
                        :typeChart="STRING_GENERAL.predictsnr"/>
                        <Prog_circular v-else/>
                    </v-sheet>
                     <v-sheet class="defaultCard text-center "  color="bgtopology">
                        <CompareCharts
                        v-if="valorRealVER.length !== 0"
                        name-primary="Real" 
                        :first-array="valorRealVER" 
                        :color-first="COLOR.compare3"
                        :color-second="COLOR.compare2"
                        :name-secundary="t('labels.predict')" 
                        :second-array="valorPredVER" 
                        :subtitle="''"
                        :title="t('analyticsPage.predvsreal2') + ' Vertical' "
                        :typeChart="STRING_GENERAL.predictsnr" />                        
                        <Prog_circular v-else/>
                    </v-sheet>
                    <v-sheet class="defaultCard text-center "  color="bgtopology">
                        <h3 class="titleSNR"> {{ t('analyticsPage.snrHorz') }} </h3>
                        <EasyDataTable
                        v-if="itemsHOR.length !== 0"
                        table-class-name="customize-table"
                        show-index
                        :headers="headers"
                        :items="itemsHOR.slice(0,10)"
                        hide-footer
                        >
                        </EasyDataTable>                        
                        <Prog_circular v-else/>
                    </v-sheet>    
                    <v-sheet class="defaultCard text-center "  color="bgtopology">
                        <h3 class="titleSNR"> {{ t('analyticsPage.snrVert') }} </h3>
                        <EasyDataTable
                        v-if="itemsVER.length !== 0"
                        table-class-name="customize-table"
                        show-index
                        :headers="headers"
                        :items="itemsVER.slice(0,10)"
                        hide-footer
                        >
                        </EasyDataTable>
                        <Prog_circular v-else/>
                    </v-sheet>    
                </v-card>
            </v-dialog>
        </v-row>

        <v-row  v-if="showError" class="ma-0 py-3 px-4">
            <h3> {{t('noInformation')}} </h3>
        </v-row>
    </v-sheet>    
</template>

<script setup lang="ts">
import {  onMounted, ref, computed, Ref } from 'vue';

/********************************
 ********** COMPONENTES *********
 *******************************/
import Prog_circular from '@/components/PrincipalComponents/Prog_circular.vue';
import CardTopology from '@/components/SmartLink/topology/CardTopology.vue';
import CompareCharts from '@/components/SmartLink/charts/CompareCharts.vue';

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from 'vuetify';
const { xs } = useDisplay();

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

/********************************
 ************ STORE *************
 *******************************/
import store from '@/store';

/********************************
 ********** CONSTANTES **********
 *******************************/
import { STRING_GENERAL } from '@/constants/labels';
import { LABELS } from '@/constants/labels';
import { COLOR } from '@/constants/colors';

/********************************
 ********** INTERFACES **********
 *******************************/
import { HEADER } from '@/interfaces/SmartLink/Tables';
import { OBJSNR } from '@/interfaces/SmartLink/IA'

/********************************
 *********** SERVICES ***********
 *******************************/
import { getAllPredictionPREDSNRByIP, getAllPredictionREALSNRByIP, getAllPredictionSNRData, getAllPredictionTABSNRByIP } from '@/services/Smartlink/Predict';


/**
 * Header de la tabla
 */
const HEADERS__PRIMARY_TABLE:(HEADER)[]    = [
{ text: computed(() => t('labels.date')).value,     value: "fecha",       sortable: true },
{ text: computed(() => t('labels.ip')).value,       value: "ip",          sortable: true },
{ text: computed(() => t('labels.status')).value,   value: "status",      sortable: true },
{ text: computed(() => t('labels.cause')).value,    value: "causa",       sortable: true },
{ text: computed(() => t('labels.value')).value,    value: "value",       sortable: true },
]    


/**
 * Se hace así para poder utilizar el i18n (verificarlo)
 */
const headers:(HEADER)[] = HEADERS__PRIMARY_TABLE;

/**
 * Mostrar el dialogo
 */
const dialog                        = ref(false);

/**
 * Valor Predictivo Horizontal para el gráfico
 */
const valorPredHOR:Ref<number[][]>  = ref([]);

/**
 * Valor Predictivo Vertical para el gráfico
 */
const valorPredVER:Ref<number[][]>  = ref([]);

/**
 * Valor Real Horizontal para el gráfico
 */
const valorRealHOR:Ref<number[][]>  = ref([]);

/**
 * Valor Real Vertical para el gráfico
 */
const valorRealVER:Ref<number[][]>  = ref([]);

/**
 * Item de la Tabla Horizontal
 */
const itemsHOR:Ref<OBJSNR[]>        = ref([]);

/**
 * Item de la Tabla Vertical
 */
const itemsVER:Ref<OBJSNR[]>        = ref([]);

/**
 * Nombre del equipo seleccionado para mostrar el Dialogo
 */
const titleDialog                   = ref('');

/**
 * Fecha del Predict Vertical del equipo seleccionado para mostrar el Dialogo
 */
const titleDateVER                  = ref('');

/**
 * Valor del Predict Vertical del equipo seleccionado para mostrar el Dialogo
 */
const titleValueVER                 = ref('');

/**
 * Fecha del Predict Horizontal del equipo seleccionado para mostrar el Dialogo
 */
const titleDateHOR                  = ref('');

/**
 * Valor del Predict Horizontal del equipo seleccionado para mostrar el Dialogo
 */
const titleValueHOR                 = ref('');

/**
 * Lista de equipos que tienen Predict 
 */
const arrayPredictSNR               = ref();

/**
 * Muestra un texto en caso no hay información en la DB o si hay algún error con las APIS
 */
const showError                     = ref(false);

/**
 * Muestra la información requerida desde la API
 */
const showCard                      = ref(true);

async function getPredictSNRData() {
    arrayPredictSNR.value = [];

    const allData = await getAllPredictionSNRData()

    showCard.value = allData.showGraphs;
    showError.value = !allData.showGraphs;

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        arrayPredictSNR.value = allData.data
    }
}

/**
 * Mostrar el dialogo con los gráficos del equipo
 * @param ip captura la IP
 * @param name captura el NOMBRE
 */
async function showDialog (ip:string, name:string) {
    titleDialog.value   = name;
    dialog.value        = true;
    valorPredVER.value  = [];
    valorPredHOR.value  = [];
    valorRealVER.value  = [];
    valorRealHOR.value  = [];
    itemsVER.value      = [];
    itemsHOR.value      = [];

    let params = { ip: ip };

    const allDataPRED = await getAllPredictionPREDSNRByIP(params)

    if( allDataPRED.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allDataPRED.status === 200 ){
        valorPredVER.value = allDataPRED.data.predVER
        valorPredHOR.value = allDataPRED.data.predHOR
        if(valorPredVER.value.length > 0) {
            let fechaVer        = new Date(valorPredVER.value.slice(-1)[0][0] + (300 * 60 * 1000) );
            titleDateVER.value  = fechaVer.toLocaleString( "es-PE");
            titleValueVER.value = (valorPredVER.value.slice(-1)[0][1]).toString();
        }
        
        if(valorPredHOR.value.length > 0) {
            let fechaHor        = new Date(valorPredHOR.value.slice(-1)[0][0] + (300 * 60 * 1000) );
            titleDateHOR.value  = fechaHor.toLocaleString("es-PE");
            titleValueHOR.value = (valorPredHOR.value.slice(-1)[0][1]).toString();
        }
    }


    const allDataREAL = await getAllPredictionREALSNRByIP(params)

    if( allDataREAL.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allDataREAL.status === 200 ){
        valorRealVER.value = allDataREAL.data.realVER
        valorRealHOR.value = allDataREAL.data.realHOR
    }

    const allDataTAB = await getAllPredictionTABSNRByIP(params)

    if( allDataTAB.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allDataTAB.status === 200 ){
       itemsVER.value = allDataTAB.data.tabVER
       itemsHOR.value = allDataTAB.data.tabHOR
    }
}

onMounted(async () => {
    await getPredictSNRData();  
})

</script>

<style scoped>
    .titleSNR{
        margin: 16px auto; 
        width: max-content;
    }
</style>